import {
  Component, OnInit, AfterViewInit, ViewChild, HostBinding, OnDestroy, ViewEncapsulation, ElementRef, TemplateRef,
  ChangeDetectorRef,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  StarbaseLoginComponent, StarbaseLoginService, fadeOutAnimation, WebApiService,
  LOG_OUT_EVENT_MESSAGE, LOG_IN_EVENT_MESSAGE, IStarbaseLoginBase
} from 'starbase-login';
import { Router, ActivatedRoute } from '@angular/router';
import { StarbaseNotificationService, StarbaseNotificationSentiment } from 'starbase-notification';
import { HttpClient } from '@angular/common/http';
import { Subscription, of } from 'rxjs';
import { PasswordScoreEnum } from 'account-management';
import { UserDataService } from '../services/user-data.service';
import { StarbaseModalOverlayService } from 'modal-overlay';
import { debounceTime, map, tap, catchError } from 'rxjs/operators';
import { StarbaseComponentMessageService } from '../services/starbase-component-message.service';
import { AppGlobalsService } from '../app-globals.service';
import { StarbaseModalButton, StarbaseModalDialogService, StarbaseModalOptions, StarbaseModalTypes } from 'starbase-modal-dialog';
import { CONTACTUS_REPORT_PROBLEM, CONTACTUS_SUGGESTION } from '../app.component';
import { environment } from 'src/environments/environment';
import { BreakpointService, BreakpointState} from '../breakpoint.service';
import { StarbaseMobileDetectionService } from 'starbase-launcher';

@Component({
  selector: 'app-login-wrapper',
  templateUrl: './login-wrapper.component.html',
  styleUrls: ['./login-wrapper.component.css'],
  animations: [ fadeOutAnimation ],
  encapsulation: ViewEncapsulation.None
})
export class LoginWrapperComponent extends StarbaseLoginComponent implements OnInit, AfterViewInit, OnDestroy, IStarbaseLoginBase {
  @HostBinding('@routeAnimation') routeAnimation = true;
  @HostBinding('style.display') display = 'block';

  @ViewChild('resendEmailModal', { static: true }) resendEmailModalTemplate: TemplateRef<any>;
  @ViewChild('resetPasswordModal', { static: true }) resetPasswordModalTemplate: TemplateRef<any>;
  @ViewChild('accountLockedModal', { static: true }) accountLockedModalTemplate: TemplateRef<any>;

  emailFrom = environment.testMode ? environment.testSupportEmailAddress : environment.supportEmailAddress;

  isHandset = false;

  // instanced copies for template
  appMinimumPwdScore = this.appGlobalsSvc.minimumPwdScore;
  appMinimumPwdLength = this.appGlobalsSvc.minimumPwdLength;

  resetPwdMode = false;
  resetPwdSuccess = false;

  token: string;
  email: string;
  phase2 = false;
  contactUsMode = 0;
  resendEmailAddress = '';

  imageUID: number;

  failedAttempts = 0;
  maxFailedAttempts = 3;
  currentLoginEmail = '';

  // eslint-disable-next-line @typescript-eslint/member-ordering
  @ViewChild('loginView', { static: false })
  private firstInputEl: StarbaseLoginComponent;
  private loginStateWrapperSubscription: Subscription;
  private breakpointSubscription: Subscription;;

  constructor(private eloginSvc: StarbaseLoginService,
              private appGlobalsSvc: AppGlobalsService,
              private ewebApi: WebApiService,
              private ehttp: HttpClient,
              private router: Router,
              private route: ActivatedRoute,
              private notiSvc: StarbaseNotificationService,
              private modalSvc: StarbaseModalDialogService,
              private loginBtnEl: ElementRef,
              private userSvc: UserDataService,
              private overlaySvc: StarbaseModalOverlayService,
              private breakpointService: BreakpointService,
              private sbCmpMsgSvc: StarbaseComponentMessageService,
              private sbMobileSvc: StarbaseMobileDetectionService,
              private cd: ChangeDetectorRef) {
    super(eloginSvc, ewebApi, ehttp, sbMobileSvc);
   }

  ngOnInit() {
    super.ngOnInit();
    //web or handset subscription through breakpoint service.
    this.breakpointSubscription = this.breakpointService.handset$.subscribe(
      isHandset => {
        this.isHandset = isHandset;
      }
    );
    this.loginStateWrapperSubscription = this.eloginSvc.loginState.subscribe(d => {
      const m = this.eloginSvc.getMessage();
      console.log('loginsvc: ' + d + '; msg: ' + m);
      if (d === true) {
        this.appGlobalsSvc.currentLoggedInUser = this.userSvc.getData(this.userSvc.GetMyAccountUri, '');
        // setTimeout(null,0.1);
        this.appGlobalsSvc.currentLoggedInUser.subscribe(currentLoggedInUser => {
          this.appGlobalsSvc.currentLoggedInContact = of(currentLoggedInUser.contact);
          this.logInSuccessImplementation(m);
        })
      } else if (d === false && this.unlocked && m === LOG_OUT_EVENT_MESSAGE) {
        this.logOutImplementation(m);
      } else {
        this.logInFailureImplementation(m);
      }
    }, e =>
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Authentication attempt failed',
          e['friendly'],
          undefined, undefined, StarbaseNotificationSentiment.Error)));
    this.appGlobalsSvc.triggerJoinNowFormEmitter.subscribe(
      () => {
        if (this.firstInputEl && !this.firstInputEl.unlocked) {
          // this.launchSignupUserWizard();
          this.router.navigateByUrl('/signup');
        }
      });

    this.imageUID = +this.route.snapshot.paramMap.get('id');

    if (this.token && this.email) {
      this.launchPhase2ResetPwdWizard();
    }
    if (this.contactUsMode) {

      switch (+this.contactUsMode) {
        case 1:
          this.appGlobalsSvc.openContactRequest('Contact Us');
          break;
        case 2:
          this.appGlobalsSvc.openContactRequest('Support Center');
          break;
        case 3:
          this.appGlobalsSvc.openContactRequest(CONTACTUS_REPORT_PROBLEM);
          break;
        case 4:
          this.appGlobalsSvc.openContactRequest(CONTACTUS_SUGGESTION);
          break;
        default:
          break;
      }
    }
    if (!this.isHandset) window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  ngAfterViewInit() {
    this.route.queryParams.subscribe(params => {
      this.token = params.token;
      this.email = params.email;
      this.contactUsMode = params.contactus;

      if (params.email && this.firstInputEl) {
        setTimeout(() => {
          const emailInput = document.querySelector('input[type="email"]') as HTMLInputElement;
          if (emailInput) {
            emailInput.value = params.email;
            emailInput.focus();
          }
        }, 100);
      }
    });

    if (this.token && this.email) {
      this.launchPhase2ResetPwdWizard();
    }

    if (history.state?.message) {
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Account Found',
          history.state.message,
          undefined, undefined, StarbaseNotificationSentiment.Info
        )
      );
    }

    if (!this.isHandset) {
      setTimeout(() => { 
        const el = document.getElementById('mainMenuBar');
        if (el) {
          el.scrollIntoView({ behavior: 'auto'});
          this.cd.markForCheck();
        } 
      }, 50);
    }
    this.firstInputEl._firstInputEl.nativeElement.focus();
    const ff = this.loginBtnEl.nativeElement.querySelector('.btn-primary');
    ff.className = 'button button-white';
    try {
      const gg = this.loginBtnEl.nativeElement.querySelector('.fa-lock');
      gg.className = 'fa fa-lock icon';
    } catch { } // may have been unlocked
    try {
      const uu = this.loginBtnEl.nativeElement.querySelector('.fa-lock-open');
      uu.className = 'fa fa-lock-open icon';
    } catch {} // may have been locked

  }
  ngOnDestroy() {
    this.loginStateWrapperSubscription.unsubscribe();
    if(this.breakpointSubscription){
      this.breakpointSubscription.unsubscribe();
    }
  }
  createAccount() {
    super.createAccount();
    // this.launchSignupUserWizard();
    this.router.navigateByUrl('/signup');
  }
  resetPassword() {
    super.resetPassword();
    this.launchSelfServeResetPwdWizard();
  }
  launchSelfServeResetPwdWizard(): void {
    this.overlaySvc.enableOverlay();
    this.resetPwdMode = true;
  }
  launchPhase2ResetPwdWizard(): void {
    this.phase2 = true;
    this.overlaySvc.enableOverlay();
    this.resetPwdMode = true;
    this.resetPwdSuccess = false;
  }

  cancelWizard(): void {
    this.resetPwdMode = false;
    this.phase2 = false;
    this.email = null;
    this.token = null;
    this.overlaySvc.disableOverlay();
  }
  logInSuccessImplementation(msg: string) {
    this.failedAttempts = 0;
    this.currentLoginEmail = '';
    // super.logInSuccessImplementation(msg);
    if (msg === LOG_IN_EVENT_MESSAGE) {
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Welcome to Research Arsenal!',
          'Logged in as ' + this.eloginSvc.getDisplayName() + '.',
          undefined, undefined, StarbaseNotificationSentiment.Info));

      if (this.imageUID) {
        this.router.navigateByUrl('/imageSingleView/' + this.imageUID);
      } else {
        this.router.navigateByUrl('/gateway');
      }
    }
  }
  logInResumingImplementation(msg: string) {

  }
  logInFailureImplementation(msg: string) {
    this.failedAttempts++;

    // if (typeof msg === 'object' && msg?['code'] === 423) {
    //   this.openAccountLockedModal();
    //   return;
    // }

    if (msg === 'Email address must be confirmed before logging in') {
      this.openResendLinkModal(this.email);
      return;
    } else if (msg === LOG_OUT_EVENT_MESSAGE) {
      msg = this.defaultFailText;
    } else if (msg.includes('password is incorrect')) {
      msg = 'Username or password is incorrect. Press \'Rset Password\' if you\'ve forgotten your password';
      this.currentLoginEmail = this.user?.Email || '';

      if (this.failedAttempts >= this.maxFailedAttempts) {
        this.openResetPasswordModal();
        return;
      }

    } else if (msg.includes('did not match our records')) {
      msg = 'Your session has expired. Please log in again.';
    }
    this.notiSvc.postNotification(
      this.notiSvc.notificationBuilder(
        'Login failed',
        msg,
        undefined, undefined, StarbaseNotificationSentiment.Error));
  }

  logOutImplementation(msg: string) {
    if (msg === LOG_OUT_EVENT_MESSAGE) {
      if (this.notiSvc.getCurrentlyNotifying()) {
        return; // make sure to display the other message, since we can't review them with "show session notifications" on this screen.
      }
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'You have logged out',
          ' ',
          undefined, undefined, StarbaseNotificationSentiment.Notice));
    }
  }
  pwdScore = (pwd: string) => this.userSvc.getRequisiteData(this.userSvc.PasswordScoreUri + pwd).pipe(
    debounceTime(1000),
    map(s => s as PasswordScoreEnum)
  );

  openResendLinkModal(email: string): void {
    this.resendEmailAddress = email;
    const resendModal = new StarbaseModalOptions(
      'Please check your email',
      '',
      [
        new StarbaseModalButton(
          'Cancel',
          () => this.modalSvc.closeModal('User canceled modal')
        ),
        new StarbaseModalButton(
          'Send',
          () => {
            if (!this.resendEmailAddress) {
              this.modalSvc.closeModal('User did not enter an email address');
              return;
            }
            this.userSvc.resendConfirmationEmail(this.resendEmailAddress).subscribe(
              () => this.notiSvc.postNotification(
                this.notiSvc.notificationBuilder(
                  'Email sent',
                  `Please check your email for a message from ${this.emailFrom} and click the link in the message to confirm your account.`,
                  undefined, 7500, StarbaseNotificationSentiment.Notice
                )
              ),
              () => this.notiSvc.notificationBuilder(
                'Error',
                'Sorry, the confirmation email could not be sent.'
              )
            );
            this.modalSvc.closeModal('User chose to resend');
          }
        )
      ],
      StarbaseModalTypes.Notice,
      this.resendEmailModalTemplate
    );
    this.modalSvc.postModal(resendModal);
  }

  
  openResetPasswordModal(): void {
    const resetModal = new StarbaseModalOptions(
      'Multiple Failed Login Attempts',
      '',
      [
        new StarbaseModalButton(
          'Cancel',
          () => {
            this.modalSvc.closeModal('User canceled password reset');
          }
        ),
        new StarbaseModalButton(
          'Reset Password',
          () => {
            this.modalSvc.closeModal('User chose to reset password');
            this.failedAttempts = 0;
            this.launchSelfServeResetPwdWizard();
          }
        )
      ],
      StarbaseModalTypes.Warning,
      this.resetPasswordModalTemplate
    );
    resetModal.dismissable = false;
    this.modalSvc.postModal(resetModal);
  }

  openAccountLockedModal(): void {
    setTimeout(() => {
      const lockedModal = new StarbaseModalOptions(
        'Account Temporarily Locked',
        '',
        [
          new StarbaseModalButton(
            'Wait it out',
            () => {
              this.modalSvc.closeModal('User chose to wait');
            }
          ),
          new StarbaseModalButton(
            'Reset Password',
            () => {
              this.modalSvc.closeModal('User chose to reset password');
              this.failedAttempts = 0;
              this.launchSelfServeResetPwdWizard();
            }
          )
        ],
        StarbaseModalTypes.Warning,
        this.accountLockedModalTemplate
      );
      lockedModal.dismissable = false;
      this.modalSvc.postModal(lockedModal);
    }, 100);
  }

  handleLockedOut(event: any): void {
    this.currentLoginEmail = this.user?.Email || '';
    this.openAccountLockedModal();
  }

  triggerEmailOnServer = (email: string) => this.userSvc.getRequisiteData(
    this.userSvc.PasswordResetRequestUri + email);

  changePassword = (pwd: string, email: string) => this.userSvc.confirmPasswordReset(
    this.email, pwd, decodeURIComponent(this.token)
  ).pipe(tap(
    {
      next: () => this.resetPwdSuccess = true,
      error: () => this.resetPwdSuccess = false
    }), catchError(async () => this.notiSvc.postNotification(
      this.notiSvc.notificationBuilder('Error',
        'Sorry, we could not process your password reset request at this time.',
        undefined, 8500, StarbaseNotificationSentiment.Error)
    )));

}
